export class DateRange {
  from: moment.Moment;
  to: moment.Moment;
}
